import "./index.scss";
import { DESCRIPTIONS_BY_TYPE } from "./utils/constants";

export const OrderRedemption = ({
  electronic,
  electronic_voucher,
  isApple,
  isLettuce
}) => {
  const isElectronic = electronic && "electronic";
  const isVoucher = electronic_voucher && "electronicVoucher";
  const electronicType =
    electronic && electronic_voucher
      ? "electronicAndElectronicVoucher"
      : isElectronic || isVoucher;
  const description = isLettuce
    ? DESCRIPTIONS_BY_TYPE["lettuce"]
    : DESCRIPTIONS_BY_TYPE[electronicType];

  return (
    <div className="order-delivery-redemption">
      <h5 className="title">Delivery &amp; redemption</h5>
      {description}
      {isApple && (
        <ul data-testid="apple-details">
          <li>The Apple Gift Card can be used two ways:</li>
          <ol>
            <li>
              For online purchases, go to apple.com/redeem to add to your Apple
              Account balance.
            </li>
            <li>Bring the Apple Gift Card to any Apple Store location.</li>
          </ol>
        </ul>
      )}

      <div className="card-details">
        <h5 className="title">Card Details</h5>
        <ul>
          <li>Free delivery</li>
          <li>Gift cards cannot be used to purchase other gift cards</li>
        </ul>
      </div>
    </div>
  );
};
